<template>
  <div>
    <CommonTab>
      <div slot="main-menu" @click="$router.push('/')">商城首页</div>
      <ChannelTabMenu slot="other-menu">
        <CommonTabMenuItem>
          <div @click="goCate(121)">
            I型糖尿病
          </div>
        </CommonTabMenuItem>
        <CommonTabMenuItem>
          <div @click="goCate(122)">
            II型糖尿病
          </div>
        </CommonTabMenuItem>
      </ChannelTabMenu>
    </CommonTab>
    <div class="img">
      <img src="@/assets/pc/images/channel/1.png" alt="" />
    </div>
    <div class="enter-container">
      <div class="enter">
        <div class="left" @click="goChoose(1)">
          <img src="@/assets/pc/images/channel/jieshao_06.jpg" alt="" />
        </div>
        <div class="right" @click="goChoose(2)">
          <img src="@/assets/pc/images/channel/jieshao_07.jpg" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommonTab from "@/components/pc/nav/CommonTab";
import ChannelTabMenu from "@components/pc/nav/ChannelTabMenu";
import CommonTabMenuItem from "@components/pc/nav/CommonTabMenuItem";
export default {
  name: "Diabetes",
  components: {
    CommonTab,
    ChannelTabMenu,
    CommonTabMenuItem
  },
  methods: {
    goCate(id) {
      this.$router.push({
        name: "GoodsList",
        params: {
          mainId: 9,
          secondId: id
        }
      });
    },
    goChoose(cate) {
      this.$router.push("/diabetesCate?cate=" + cate);
    }
  }
};
</script>

<style lang="stylus" scoped>
.img
  img
    width 100%
    height 100%
.enter-container
  width 100%
  background #f1f8fe
  .enter
    width 1200px
    height 419px
    padding-top 50px
    margin 20px auto 0
    display flex
    justify-content space-between
    .left
      width 50%
      img
        width 100%
    .right
      width 50%
      img
        width 100%
</style>
